export default [
    {
        path: '/jobs',
        name: 'jobs',
        components: {
            default: () => import(/* webpackChunkName: "jobs" */ '@/views/content/Jobs'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        components: {
            default: () => import(/* webpackChunkName: "privacy-policy" */ '@/views/content/PrivacyPolicy'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
    {
        path: '/terms-and-conditions',
        name: 'terms-and-conditions',
        components: {
            default: () => import(/* webpackChunkName: "terms-and-conditions" */ '@/views/content/TermsAndConditions'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
    {
        path: '/tag-rugby-trust',
        name: 'tag-rugby-trust',
        components: {
            default: () => import(/* webpackChunkName: "terms-and-conditions" */ '@/views/content/TRTPage'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
    {
        path: '/accessibility',
        name: 'accessibility',
        components: {
            default: () => import(/* webpackChunkName: "terms-and-conditions" */ '@/views/Accessibility'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
    {
        path: '/sustainability',
        name: 'sustainability',
        components: {
            default: () => import(/* webpackChunkName: "terms-and-conditions" */ '@/views/SustainabilityPage'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
    {
        path: '/growers',
        name: 'growers',
        components: {
            default: () => import(/* webpackChunkName: "terms-and-conditions" */ '@/views/GrowersPage'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
    {
        path: '/christmas1',
        name: 'christmas1',
    },
    {
        path: '/christmas2',
        name: 'christmas2',
    },
    {
        path: '/christmas3',
        name: 'christmas3',
    },
    {
        path: '/christmas4',
        name: 'christmas4',
    },
    {
        path: '/christmas5',
        name: 'christmas5',
    },
    {
        path: '/christmas6',
        name: 'christmas6',
    },
    {
        path: '/christmas7',
        name: 'christmas7',
    },
    {
        path: '/christmas8',
        name: 'christmas8',
    },
    {
        path: '/christmas9',
        name: 'christmas9',
    },
    {
        path: '/christmas10',
        name: 'christmas10',
    },
];
